export default __webpack_public_path__ + "static/about_graphic-d2dc74d99e030828031971adf398d21c.png";